import React from "react";
import Tablet from "./Tablet";

export default function Table() {
  return (
    <div className="about-me__table-container">
      <h2>Skills</h2>
      <Tablet />
    </div>
  );
}
